import list from './list';
import add from './add';
import edit from './edit';

const module = {
  namespaced: true,
  modules: {
    list,
    add,
    edit,
  },
};

export default module;
